/**
 * Hero: display:none olan masaüstü/mobil kopyalardaki videoları durdurur;
 * birden fazla video hücresi varsa yalnızca görünür alandakileri oynatır.
 */
function initHeroVideoPerformance() {
  const videos = document.querySelectorAll('.hero video.hero__media');
  if (!videos.length) return;

  const pauseInHiddenWrapper = () => {
    document.querySelectorAll('.hero .hero__media-wrapper').forEach((wrap) => {
      const hidden = window.getComputedStyle(wrap).display === 'none';
      wrap.querySelectorAll('video').forEach((v) => {
        if (hidden) {
          v.pause();
          try {
            v.preload = 'none';
          } catch {
            /* ignore */
          }
        }
      });
    });
  };

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const v = entry.target;
        if (!(v instanceof HTMLVideoElement)) return;

        const wrap = v.closest('.hero__media-wrapper');
        if (wrap && window.getComputedStyle(wrap).display === 'none') return;

        if (entry.isIntersecting && entry.intersectionRatio > 0.08) {
          v.play().catch(() => {});
        } else {
          v.pause();
        }
      });
    },
    { threshold: [0, 0.1, 0.25], rootMargin: '0px' }
  );

  pauseInHiddenWrapper();
  videos.forEach((v) => io.observe(v));

  let resizeT;
  window.addEventListener(
    'resize',
    () => {
      clearTimeout(resizeT);
      resizeT = setTimeout(pauseInHiddenWrapper, 150);
    },
    { passive: true }
  );
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeroVideoPerformance);
} else {
  initHeroVideoPerformance();
}

document.addEventListener('shopify:section:load', initHeroVideoPerformance);
